import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import MoroccoScs from './containers/moroccoForm/MoroccoSca';
import './config/i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<MoroccoScs />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
